/* eslint-disable import/no-mutable-exports */
const env = process.env.REACT_APP_ENV;

const LIVE_CDN_HOST = 'd1r8hfx2wmid45.cloudfront.net';
const STAGING_CDN_HOST = 'd372rqnest612b.cloudfront.net';

// Determine API endpoint based on current hostname
const getApiEndpoint = () => {
  if (typeof window !== 'undefined') {
    const { hostname, origin } = window.location;

    // Check if localhost
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return 'http://localhost:4076/v1';
      // return 'https://tinybits-api.iscriptsdemo.com/v1';
      // return 'https://api.tinybits.app/v1';
    }

    // Check if manage-tinybits.iscriptsdemo.com
    if (origin.includes('manage-tinybits.iscriptsdemo.com')) {
      return 'https://tinybits-api.iscriptsdemo.com/v1';
    }

    if (origin.includes('https://manage.tinybits.app')) {
      return 'https://api.tinybits.app/v1';
    }
  }

  // Default fallback
  return 'http://localhost:4075/v1';
};

const getCdnHost = () => {
  const fromEnv = process.env.REACT_APP_CLOUDFRONT_URL || process.env.REACT_APP_CDN_URL;
  if (fromEnv) {
    return fromEnv.replace(/^https?:\/\//, '').replace(/\/$/, '');
  }

  if (typeof window !== 'undefined') {
    const { hostname, origin } = window.location;

    if (hostname === 'manage.tinybits.app' || origin.includes('manage.tinybits.app')) {
      return LIVE_CDN_HOST;
    }

    if (
      origin.includes('manage-tinybits.iscriptsdemo.com') ||
      origin.includes('bp.iscriptsdemo.com')
    ) {
      return STAGING_CDN_HOST;
    }

    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return STAGING_CDN_HOST;
    }
  }

  if (env === 'production') return LIVE_CDN_HOST;
  if (env === 'staging') return STAGING_CDN_HOST;

  return STAGING_CDN_HOST;
};

let envValues = {
  PORT: 80,
  REACT_APP_API_ENDPOINT: getApiEndpoint(),
  REACT_APP_API_FRONT_END: 'http://localhost:4075',
  REACT_APP_API_PERMISSION_DENIED: 'http://localhost:4075/permission',
  REACT_APP_SHOW_COOKIE_BOX: false,
  SOCKET_STATUS: 'OFF',
  COLLECTIONURL: process.env.REACT_APP_COLLECTIONURL,
  CDN_HOST: getCdnHost(),
  STAGING_CDN_HOST,
};
switch (env) {
  case 'staging':
    envValues = {
      PORT: 80,
      REACT_APP_API_ENDPOINT: 'https://bp-api.iscriptsdemo.com/v1',
      REACT_APP_API_FRONT_END: 'https://bp.iscriptsdemo.com',
      REACT_APP_API_PERMISSION_DENIED: 'https://bp.iscriptsdemo.com/permission',
      REACT_APP_SHOW_COOKIE_BOX: false,
      SOCKET_STATUS: 'ON',
      COLLECTIONURL: process.env.REACT_APP_COLLECTIONURL,
      CDN_HOST: getCdnHost(),
      STAGING_CDN_HOST,
    };
    break;
  case 'production':
    envValues = {
      PORT: 80,
      REACT_APP_API_ENDPOINT: 'https://api.tinybits.app/v1',
      REACT_APP_API_FRONT_END: 'https://manage.tinybits.app',
      REACT_APP_API_PERMISSION_DENIED: 'https://manage.tinybits.app/permission',
      REACT_APP_SHOW_COOKIE_BOX: false,
      SOCKET_STATUS: 'ON',
      COLLECTIONURL: process.env.REACT_APP_COLLECTIONURL,
      CDN_HOST: getCdnHost(),
      STAGING_CDN_HOST,
    };
    break;
  case 'development':
    envValues = {
      PORT: 80,
      REACT_APP_API_ENDPOINT: getApiEndpoint(),
      REACT_APP_API_FRONT_END: 'http://localhost:3000',
      REACT_APP_API_PERMISSION_DENIED: 'http://localhost:3000/permission',
      REACT_APP_SHOW_COOKIE_BOX: false,
      SOCKET_STATUS: 'ON',
      COLLECTIONURL: process.env.REACT_APP_COLLECTIONURL,
      CDN_HOST: getCdnHost(),
      STAGING_CDN_HOST,
    };
    break;
  default:
    envValues = {
      PORT: 80,
      REACT_APP_API_ENDPOINT: getApiEndpoint(),
      REACT_APP_API_FRONT_END: 'http://localhost:3000',
      REACT_APP_API_PERMISSION_DENIED: 'http://localhost:3000/permission',
      REACT_APP_SHOW_COOKIE_BOX: false,
      SOCKET_STATUS: 'OFF',
      COLLECTIONURL: process.env.REACT_APP_COLLECTIONURL,
      CDN_HOST: getCdnHost(),
      STAGING_CDN_HOST,
    };
    break;
}

export { LIVE_CDN_HOST, STAGING_CDN_HOST, getCdnHost };
export default envValues;
